import React  from 'react';
import PropTypes from 'prop-types';
import { colors } from '../../../../shared/styles';

export const itemWidth = 170;

export function transpose(arr, rowSize) {
  if (!arr || !rowSize) return arr;

  const res = [];
  const len = arr.length;
  const numRows = Math.ceil(len/rowSize);
  for (let col = 0; col < rowSize; ++col) {
    for (let row = 0; row < numRows; ++row) {
      const idx = row*rowSize + col;
      if (idx < len) {
        res.push(arr[idx]);
      }
    }
  }
  return res;
}

export const StdCourseItem = ({course, selected, onStdCourseToggled}) => {
  const onChange = () => onStdCourseToggled(course.cpid, selected, course);
  const checkboxColor = selected ? colors.blue : 'lightgrey';
  return (
    <li style={{width:itemWidth, display:'inline-block'}}>
      {/*<Checkbox*/}
      {/*  className='race-type'*/}
      {/*  onCheck={onChange}*/}
      {/*  iconStyle={{fill: checkboxColor}}*/}
      {/*  labelStyle={{whiteSpace:'nowrap'}}*/}
      {/*  label={course.label}*/}
      {/*  checked={selected}/>*/}
    </li>
  );
};

StdCourseItem.propTypes = {
  course: PropTypes.object.isRequired,
  selected: PropTypes.bool.isRequired,
  onStdCourseToggled: PropTypes.func.isRequired
};



/** WEBPACK FOOTER **
 ** ./components/race/create/AddCourses/StdCourseItem.js
 **/